import { useAtom } from 'jotai';
import { MCDataQuestion } from '../DomainModels';
import { useI18n } from "src/utils/lni18n";
import { MCTestService } from './MCTestService';
import classes from "./McTest.module.scss";
import LnIcon from 'src/components/LnIcon';
import DOMPurify from 'dompurify';
import { useConfirm } from 'src/components/Modalservice/UseConfirm';

const QuestionsList = (props: { readOnly: boolean, service: MCTestService, data: MCDataQuestion[], onDelete: (index: number) => void, onEdit: (index: number) => void }) => {
    const { languageService: t } = useI18n();
    const { data, onEdit, onDelete, service, readOnly } = props;
    const confirm = useConfirm();

    if (!data) return null;

    const addQuestion = () => {
        const newData =  service.addQuestion();
        onEdit(newData.Questions.length - 1);
    }
    const deleteQuestion = (i: number) => {
        confirm("md" , t.getText("delete"),
                <div className="preserve-white" >{t.getText("really.sure")}</div> )
        .then((res: boolean) => {
            if (res) {
                onDelete(i);
            }
        }).catch((e: Error) => {});
    }

    return <div className="p-3 mb-3">
        <div className='mb-3'><b>{t.getText("questions")}</b> ( {t.getText("numofquestions")} {data?.length ?? 0})</div>
        {!readOnly &&
            <button  onClick={addQuestion} type='button' className='btn btn-primary btn-small mb-3' >{t.getText("add")}</button>
        }

        {data.map((d, i) => <div key={d.Index} className={`d-flex px-3 ${ d.Checked ? "bg-primary-lightest" : ''}`}>
            <button type='button' className='d-flex flex-fill btn btn-link noFocus' onClick={() => onEdit(d.Index)}>
                <div className={`${classes.testListText}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(d.Question) }} ></div>
            </button>

            {(data.length > 2) && <button disabled={readOnly} className="btn btn-link ms-3" type="button" onClick={() => deleteQuestion(i)}>
                <LnIcon name="delete" className='icon-small' />
            </button>}

        </div>)}

    </div>

}

export default QuestionsList;

